module.exports = __webpack_public_path__ + "static/media/house4lg.b7546401.png";